<div class="d-flex">
    <!-- class="sidenav-bar-container" -->
    <div>
        <app-superadminsidenav></app-superadminsidenav>
    </div>
    <div class="dashboard-main-div">
        <div class=" pad-t10">


            <div style="margin: 0px 27px;">
                <div class="summary-grid">
                    <div class="summary-card">
                        <div class="summary-title">Total Restaurants</div>
                        <div class="summary-value">{{ totalResturants | number }}</div>
                    </div>
                    <div class="summary-card">
                        <div class="summary-title">Active Restaurants</div>
                        <div class="summary-value">{{ activeResturants | number }}</div>
                    </div>
                    <div class="summary-card">
                        <div class="summary-title">Inactive Restaurants</div>
                        <div class="summary-value">{{ inactiveResturants | number }}</div>
                    </div>
                    <div class="summary-card">
                        <div class="summary-title">Total Users</div>
                        <div class="summary-value">{{ totalUser | number }}</div>
                    </div>
                    <div class="summary-card">
                        <div class="summary-title">Active Users</div>
                        <div class="summary-value">{{ activeUsers | number }}</div>
                    </div>
                    <div class="summary-card">
                        <div class="summary-title">Inactive Users</div>
                        <div class="summary-value">{{ inactiveUser | number }}</div>
                    </div>
                </div>
            </div>




            <div style="margin: 15px 27px;">
                <div class="summary-grid">
                    <div class="summary-card" *ngFor="let card of dashboardData.summaryCards">
                        <div class="summary-title">{{ card.title }}</div>
                        <div class="summary-value">{{ card.value | number }}</div>
                        <div class="summary-subtitle">{{ card.subtitle }}</div>
                    </div>
                </div>



                <div class="chart-grid">
                    <div class="panel">
                        <div class="panel-header">
                            <div>
                                <h3>Number of People with Dietary Preferences (Top 10)</h3>
                                <p>Count of diners avoiding specific ingredients</p>
                            </div>
                        </div>

                        <apx-chart *ngIf="chartsReady" [series]="dietaryPreferencesChart.series!"
                            [chart]="dietaryPreferencesChart.chart!" [xaxis]="dietaryPreferencesChart.xaxis!"
                            [yaxis]="dietaryPreferencesChart.yaxis!"
                            [plotOptions]="dietaryPreferencesChart.plotOptions!"
                            [dataLabels]="dietaryPreferencesChart.dataLabels!"
                            [colors]="dietaryPreferencesChart.colors!" [grid]="dietaryPreferencesChart.grid!"
                            [tooltip]="dietaryPreferencesChart.tooltip!"
                            [legend]="dietaryPreferencesChart.legend!"></apx-chart>
                    </div>

                    <div class="panel">
                        <div class="panel-header">
                            <div>
                                <h3>Number of People with Food Allergies (Top 10)</h3>
                                <p>Count of diners with allergies to specific ingredients</p>
                            </div>
                        </div>

                        <apx-chart *ngIf="chartsReady" [series]="foodAllergiesChart.series!"
                            [chart]="foodAllergiesChart.chart!" [xaxis]="foodAllergiesChart.xaxis!"
                            [yaxis]="foodAllergiesChart.yaxis!" [plotOptions]="foodAllergiesChart.plotOptions!"
                            [dataLabels]="foodAllergiesChart.dataLabels!" [colors]="foodAllergiesChart.colors!"
                            [grid]="foodAllergiesChart.grid!" [tooltip]="foodAllergiesChart.tooltip!"
                            [legend]="foodAllergiesChart.legend!"></apx-chart>
                    </div>

                    <div class="panel">
                        <div class="panel-header">
                            <div>
                                <h3>Percentage Distribution of Food Allergies (Top 10)</h3>
                                <p>Breakdown of reported allergies by type</p>
                            </div>
                        </div>

                        <apx-chart *ngIf="chartsReady" [series]="allergyDistributionChart.series!"
                            [chart]="allergyDistributionChart.chart!" [labels]="allergyDistributionChart.labels!"
                            [colors]="allergyDistributionChart.colors!" [legend]="allergyDistributionChart.legend!"
                            [dataLabels]="allergyDistributionChart.dataLabels!"
                            [tooltip]="allergyDistributionChart.tooltip!"
                            [responsive]="allergyDistributionChart.responsive!"></apx-chart>
                    </div>

                    <div class="panel">
                        <div class="panel-header">
                            <div>
                                <h3>Food Preferences Across Dietary Types (Top 10)</h3>
                                <p>Vegan and vegetarian preferences by category</p>
                            </div>
                        </div>

                        <apx-chart *ngIf="chartsReady" [series]="preferenceByCategoryChart.series!"
                            [chart]="preferenceByCategoryChart.chart!" [xaxis]="preferenceByCategoryChart.xaxis!"
                            [yaxis]="preferenceByCategoryChart.yaxis!"
                            [plotOptions]="preferenceByCategoryChart.plotOptions!"
                            [dataLabels]="preferenceByCategoryChart.dataLabels!"
                            [colors]="preferenceByCategoryChart.colors!" [grid]="preferenceByCategoryChart.grid!"
                            [tooltip]="preferenceByCategoryChart.tooltip!" [legend]="preferenceByCategoryChart.legend!"
                            [stroke]="preferenceByCategoryChart.stroke!"></apx-chart>
                    </div>
                </div>

            </div>

        </div>

    </div>

</div>